/** flatten nested structure json file to just key-value pairs  */
export const flattenMessages = (nestedMessages, prefix = '') =>
  Object.keys(nestedMessages).reduce((messages, key) => {
    if (key === '0') {
      return messages;
    }
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'string') {
      messages[prefixedKey] = value; // eslint-disable-line
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});

/** flatten nested structure json file to just key-value pairs
 * using the default keys when not available
 */
export const flattenMessagesDefault = (nestedMessages, defaultMessages, prefix = '') => {
  const defaults = flattenMessages(defaultMessages, prefix);
  const messages = flattenMessages(nestedMessages, prefix);

  return Object.assign(defaults, messages);
};

/** TODO react-intl doesn't detect currency. need to
 * figure out how to extract currency code from locale
 */
export const intlFormat = {
  number: {
    currency: { style: 'currency', currency: 'USD' },
  },
};

// formats message object for usage
export const getFormattedMessages = (messageObj, intl) =>
  Object.keys(messageObj).reduce(
    (formattedMessages, messageId) => ({
      ...formattedMessages,
      [messageId]: intl.formatMessage(messageObj[messageId]),
    }),
    {}
  );
